<template>
  <v-dialog v-model="showModal" width="400" @click:outside=closeDialog>
      <v-card max-width="400">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="text-h5 text-medium-emphasis ps-2 title-text" >edit broker txn</div>
          <v-btn icon="mdi-close" variant="text" @click=closeDialog></v-btn>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-sheet class="mx-auto" width="300">
            <v-form @submit.prevent ref="form">
              <v-text-field label="id" variant="underlined" class="form_field" v-model="this.currentRow.id" disabled></v-text-field>
              <v-text-field :rules="[required]" label="txn date" variant="underlined" class="form_field" v-model="this.txn_date_copy" type="date"></v-text-field>
              <v-text-field :rules="[required]" label="ticker" variant="underlined" class="form_field" v-model="this.currentRow.ticker"></v-text-field>
              <v-select :rules="[required]" :items="txnTypeOptions" label="txn type" variant="underlined" class="form_field" v-model="this.currentRow.txn_type"></v-select>
              <v-alert v-if="this.currentRow.txn_type === 'capital_return_adj'" type="info" density="compact" variant="tonal" class="mb-2">enter cash received as negative value</v-alert>
              <v-alert v-if="this.currentRow.txn_type === 'tax_adj'" type="info" density="compact" variant="tonal" class="mb-2">+ve value increases cost base</v-alert>
              <template v-if="!isAdjustment">
                <v-text-field :rules="[required, numeric]" label="qty" variant="underlined" class="form_field" v-model="this.currentRow.qty" inputmode="decimal"></v-text-field>
                <v-text-field :rules="[required, numeric]" label="price" variant="underlined" class="form_field" v-model="this.currentRow.price" inputmode="decimal"></v-text-field>
                <v-text-field :rules="[required, numeric]" label="brokerage" variant="underlined" class="form_field" v-model="this.currentRow.brokerage" inputmode="decimal"></v-text-field>
              </template>
              <v-text-field :rules="[required]" label="currency" variant="underlined" class="form_field" v-model="this.currentRow.currency"></v-text-field>
              <v-text-field v-if="this.currentRow.currency != 'AUD'" :rules="[required, numeric]" label="spot fx" variant="underlined" class="form_field" v-model="this.currentRow.base_currency_spot_rate" inputmode="decimal"></v-text-field>
              <template v-if="isAdjustment">
                <v-btn-toggle v-model="input_mode" mandatory class="mb-4">
                  <v-btn value="per_unit" size="small">per unit</v-btn>
                  <v-btn value="total" size="small">total</v-btn>
                </v-btn-toggle>
                <v-text-field :rules="[required, numeric]" :label="input_mode === 'per_unit' ? 'per unit amount' : 'total amount'" variant="underlined" class="form_field" v-model="adjustment_amount" inputmode="decimal"></v-text-field>
              </template>
              <template v-if="!isAdjustment">
                <v-text-field label="external id" variant="underlined" class="form_field" v-model="this.currentRow.external_txn_id"></v-text-field>
              </template>
              <v-text-field label="description" variant="underlined" class="form_field" v-model="this.currentRow.description"></v-text-field>
            </v-form>
          </v-sheet>
        </v-card-text>
        <template v-slot:actions>
          <v-row align="center" justify="end" class="actionsRow">
            <v-btn v-on:click="submitEditRecord" class="mt-2 submit_button" type="submit" block>update</v-btn>
            <v-btn v-on:click="submitDeleteRecord" class="mt-2 submit_button" type="submit" block>delete</v-btn>
          </v-row>
        </template>
      </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';
import moment from 'moment';

export default {
  props: {
    show: Boolean,
    currentRow: Object,
  },
  data() {
    return {
      txn_date_formatted: '', //yyyy-mm-dd
      input_mode: 'per_unit',
      adjustment_amount: '',
      txnTypeOptions: [
        { title: 'buy', value: 'buy' },
        { title: 'sell', value: 'sell' },
        { title: 'demerger', value: 'demerger' },
        { title: 'split', value: 'split' },
        { title: 'capital return adj', value: 'capital_return_adj' },
        { title: 'tax adj', value: 'tax_adj' },
      ],
    }
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    showModal: {
      get () {
        return this.show
      }
    },
    isAdjustment() {
      return this.currentRow?.txn_type === 'capital_return_adj' || this.currentRow?.txn_type === 'tax_adj';
    },
  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    async submitDeleteRecord(e) {
      try {
        e.preventDefault();
        await axios.delete('/securities/txns/' + this.currentRow.id,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
          }
        });
          this.$parent.getBrokerTxns(); // update txn list on local
          this.$parent.getOpenPositionData(); // update open position data on local
          this.$emit("close"); // close modal via parent

      } catch (error) {
        this.showSnackbar({ message: 'Failed to delete broker transaction' });
      }
    },
    async submitEditRecord(e) {
      try {
        e.preventDefault();
        const data = {
          txn_date: this.txn_date_copy,
          ticker: this.currentRow.ticker,
          txn_type: this.currentRow.txn_type,
          currency: this.currentRow.currency,
          base_currency_spot_rate: this.currentRow.base_currency_spot_rate,
          description: this.currentRow.description || null
        };

        if (this.isAdjustment) {
          data.input_mode = this.input_mode;
          if (this.input_mode === 'per_unit') {
            data.per_unit_amount = this.adjustment_amount;
          } else {
            data.total_amount = this.adjustment_amount;
          }
        } else {
          data.qty = this.currentRow.qty;
          data.price = this.currentRow.price;
          data.brokerage = this.currentRow.brokerage;
          data.external_txn_id = this.currentRow.external_txn_id;
        }

        await axios.request({
          url: "/securities/txns/" + this.currentRow.id,
          method: "PUT",
          headers: {
              Authorization: `Bearer ${this.token}`
          },
          data
        });
          this.$parent.getBrokerTxns(); // update txn list on local
          this.$parent.getOpenPositionData(); // update open position data on local
          this.$emit("close"); // close modal via parent
      } catch (error) {
        const message = error.response?.data?.error || 'Failed to update broker transaction';
        this.showSnackbar({ message });
      }
    },
    required (v) {
        return (v !== null && v !== undefined && v !== '') || 'required'
    },
    numeric (v) {
        return !isNaN(v) || 'must be a number'
    },
    closeDialog(){
      this.$parent.getBrokerTxns();
      this.$emit('close');
    },
  },
  watch: {
    currentRow(newVal) {
      this.txn_date_copy = moment(newVal.txn_date).format('YYYY-MM-DD');
      if (newVal.txn_type === 'capital_return_adj' || newVal.txn_type === 'tax_adj') {
        this.input_mode = 'per_unit';
        this.adjustment_amount = newVal.price;
      }
    }
  }
}
</script>

<style scoped>
.title-text, .body-text, .form_field, .submit_button {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.actionsRow{
  margin-bottom: 5px;
}


</style>
